<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TazApp',
  
  beforeCreate() {
    this.$store.dispatch('auth/getUser').then(() => {});
  },
  computed: {
    ...mapGetters('auth', ['getUser']),
  },
};
</script>

<style>

</style>
